import React, { useState } from 'react';
import Customer from '../../../types/Customer';
import AdminRadiobox from '../../admin-radiobox';
import useUpdateCustomerRole from '../../../hooks/use-update-customer-role';
import Button from '../../button';

interface Props {
  customer: Customer;
}

const AdminUserRoleForm: React.FC<Props> = ({ customer }) => {
  const [role, setRole] = useState(customer.role);
  const [message, setMessage] = useState('');
  const updateCustomerRole = useUpdateCustomerRole();

  const onClick = () => {
    updateCustomerRole(process.env.SITE!, customer.id, role);

    setMessage('Successfully updated role details.');
  };

  return (
    <form>
      <h2>Role</h2>
      <div className="roles">
        {[
          {
            id: 'consumer',
            label: 'Consumer',
          },
          {
            id: 'internal',
            label: 'Volvo Internal',
          },
          {
            id: 'retailer',
            label: 'Volvo Retailer',
          },
          {
            id: 'government',
            label: 'Government User',
          },
          {
            id: 'TDS',
            label: 'Tourist and Diplomat Sales',
          },
          {
            id: 'callCenter',
            label: 'KCC Call Center',
          },
          {
            id: 'Fleet',
            label: 'Fleet User',
          },
          {
            id: 'retailGuideVendor',
            label: 'Retailer Guide Vendor',
          },
          // @ts-ignore
        ].map((r) => (
          <AdminRadiobox
            key={r.id}
            name="role"
            id={r.id}
            label={r.label}
            checked={r.id.toLowerCase() === role.toLowerCase()}
            onChange={() => setRole(r.id)}
          />
        ))}
      </div>
      {message && <p>{message}</p>}
      <Button text="Save" onClick={onClick} />
      {/* language=CSS */}
      <style jsx>{`
        .roles {
          display: flex;
          flex-wrap: wrap;
        }

        .roles > :global(.radiobox-group) {
          flex-grow: 0;
          width: 33%;
          margin-bottom: 1rem;
        }
      `}</style>
    </form>
  );
};

export default AdminUserRoleForm;
